module.exports = __webpack_public_path__ + "img/abg2.b46909c5.png";